/* Produktseiten-Verhalten (parfumtesten):
   Weiterlesen-Klappe, Verfügbarkeits-Anzeige, Galerie-Sollbild
   je Variante und Sparbalken. Update-Kanäle wie im alten Setup:
   change-Event am Varianten-Input (delegiert) + variant:change. */
(() => {
  'use strict';

  if (window.DftProductReady) return;
  window.DftProductReady = true;

  /* ---------- Beschreibung: Weiterlesen ---------- */
  const setupClamps = (root) => {
    root.querySelectorAll('.dft-clamp').forEach((box) => {
      if (box.dataset.dftWired) return;
      box.dataset.dftWired = '1';
      const toggle = box.parentElement.querySelector('.dft-clamp__more');
      if (!toggle) return;

      const measure = () => {
        const em = parseFloat(getComputedStyle(box).fontSize) || 14;
        const isLong = box.scrollHeight > em * 10.5 + 12;
        if (isLong) {
          box.setAttribute('data-long', '');
          if (!box.hasAttribute('data-offen')) box.setAttribute('data-shut', '');
          box.removeAttribute('data-kurz');
          toggle.hidden = false;
        } else {
          box.removeAttribute('data-long');
          box.removeAttribute('data-shut');
          box.setAttribute('data-kurz', '');
          toggle.hidden = true;
        }
      };

      toggle.addEventListener('click', () => {
        const shut = box.hasAttribute('data-shut');
        if (shut) {
          box.removeAttribute('data-shut');
          box.setAttribute('data-offen', '');
          toggle.textContent = 'Weniger lesen';
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          box.setAttribute('data-shut', '');
          box.removeAttribute('data-offen');
          toggle.textContent = 'Weiterlesen';
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      measure();
      window.addEventListener('load', measure, { once: true });

      let raf = 0;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(measure);
      });
    });
  };

  /* ---------- Verfügbarkeit ---------- */
  const availState = (entry, lowMax) => {
    if (!entry || !entry.av) return 'out';
    if (entry.track && entry.qty > 0 && entry.qty < lowMax) return 'low';
    return 'ok';
  };

  const paintAvail = (box, entry) => {
    const lowMax = parseInt(box.dataset.lowMax || '5', 10);
    const mode = availState(entry, lowMax);
    box.dataset.mode = mode;
    const label =
      mode === 'ok'
        ? box.dataset.textOk
        : mode === 'low'
          ? (box.dataset.textLow || '').replace('#n#', entry.qty).replace('{n}', entry.qty)
          : box.dataset.textOut;
    const target = box.querySelector('[data-dft-avail-text]');
    if (target) target.innerHTML = '<strong>' + label + '</strong>';
  };

  const availBoxes = () => document.querySelectorAll('.dft-avail[data-dft-avail]');

  const availMapFor = (box) => {
    const holder = box.parentElement.querySelector('script[data-dft-stockmap]');
    if (!holder) return null;
    try {
      const rows = JSON.parse(holder.textContent);
      const map = {};
      rows.forEach((r) => {
        map[String(r[0])] = { qty: r[1], av: r[2] === 1, track: r[3] === 1, media: r[4] || 0, price: r[5] || 0 };
      });
      return map;
    } catch {
      return null;
    }
  };

  /* ---------- Galerie: Sollbild je Variante durchsetzen ---------- */
  let wantedMediaId = null; // volle data-media-id (inkl. Section-Präfix)
  let standardMediaId = '';

  const galleryEl = () => document.querySelector('media-gallery');

  const mediaPrefix = () => {
    const gallery = galleryEl();
    const first = gallery && gallery.querySelector('[data-media-id]');
    if (!first) return '';
    const id = first.dataset.mediaId;
    return id.slice(0, id.lastIndexOf('-') + 1);
  };

  const applyGallery = () => {
    if (!wantedMediaId) return;
    const gallery = galleryEl();
    if (!gallery) return;
    const ziel = gallery.querySelector('[data-media-id="' + wantedMediaId + '"]');
    if (!ziel) return;
    const aktiv = gallery.querySelector('.is-active[data-media-id]');
    if (aktiv === ziel) return;
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(wantedMediaId, true);
    }
  };

  const watchGallery = () => {
    const gallery = galleryEl();
    if (!gallery || gallery.dataset.dftWacht) return;
    gallery.dataset.dftWacht = '1';
    let stiller = 0;
    const beobachter = new MutationObserver(() => {
      clearTimeout(stiller);
      stiller = setTimeout(applyGallery, 120);
    });
    beobachter.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  /* ---------- Sparbalken ---------- */
  const paintSaveline = () => {
    document.querySelectorAll('.dft-saveline').forEach((line) => {
      let steps;
      try {
        steps = JSON.parse(line.dataset.steps || '{}');
      } catch {
        steps = {};
      }
      const picked = document.querySelector(
        '.product-form__input--pill input[type="radio"]:checked, variant-selects input[type="radio"]:checked'
      );
      let pct = 0;
      if (picked) {
        const found = String(picked.value).match(/(\d+)\s*ml\b/i);
        const key = found ? (found[1] + 'ml').toLowerCase() : '';
        if (key && Object.hasOwn(steps, key)) pct = steps[key];
      }
      const fill = line.querySelector('.dft-saveline__fill');
      if (fill) {
        fill.style.width = pct + '%';
        fill.style.background = '#1a7f37';
        fill.style.height = '100%';
        fill.style.display = 'block';
      }
      line.querySelectorAll('.dft-saveline__mark').forEach((mark) => {
        const at = parseFloat(mark.dataset.at || '0');
        mark.classList.toggle('is-hit', pct >= at);
      });
    });
  };

  /* ---------- Steuer-/Versandhinweis unter dem Preis ---------- */
  let cartTotal = 0;
  const FREI_AB = 4900;

  const paintTax = (entry) => {
    const tax = document.querySelector('.product__info-container .product__tax');
    if (!tax || !entry) return;
    if (!tax.dataset.dftOriginal) tax.dataset.dftOriginal = tax.innerHTML;
    if (cartTotal + entry.price >= FREI_AB) {
      tax.innerHTML = 'Inkl. MwSt. <span class="dft-gratis-wort">Kostenloser Versand</span>';
    } else {
      tax.innerHTML = tax.dataset.dftOriginal;
    }
  };

  const repaintTaxForCurrent = () => {
    availBoxes().forEach((box) => {
      const map = availMapFor(box);
      const entry = map && map[box.dataset.current];
      if (entry) paintTax(entry);
    });
  };

  /* ---------- Zentrale Aktualisierung ---------- */
  const applyVariant = (variantId) => {
    if (!variantId) return;
    availBoxes().forEach((box) => {
      const map = availMapFor(box);
      const entry = map && map[String(variantId)];
      if (!entry) return;
      box.dataset.current = String(variantId);
      paintAvail(box, entry);
      paintTax(entry);
      const zielMedia = entry.media !== 0 ? String(entry.media) : standardMediaId;
      if (zielMedia) {
        wantedMediaId = mediaPrefix() + zielMedia;
        applyGallery();
        setTimeout(applyGallery, 300);
      }
    });
    paintSaveline();
    setTimeout(raeumeTeilerAuf, 200);
  };

  const readVariantFromForm = () => {
    const idField = document.querySelector(
      'product-info input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    if (idField && idField.value) applyVariant(String(idField.value));
  };

  /* Fremde/doppelte „Parfümprobe“-Zeilen entfernen – sichtbar bleibt
     ausschließlich der erste eigene Teiler. */
  const raeumeTeilerAuf = () => {
    const teiler = Array.from(document.querySelectorAll('.dft-teiler'));
    teiler.slice(1).forEach((t) => t.remove());
    document
      .querySelectorAll('.product__info-container div, .product__info-container p, .product__info-container legend, .product__info-container span')
      .forEach((el) => {
        if (el.classList.contains('dft-teiler')) return;
        if (el.closest('.dft-teiler') || el.closest('label') || el.closest('button')) return;
        if (el.children.length) return;
        if (el.textContent.trim() !== 'Parfümprobe') return;
        el.style.setProperty('display', 'none', 'important');
      });
  };

  /* ---------- Verdrahtung ---------- */
  const boot = () => {
    setupClamps(document);
    paintSaveline();
    watchGallery();
    raeumeTeilerAuf();
    setTimeout(raeumeTeilerAuf, 600);
    availBoxes().forEach((box) => {
      if (box.dataset.mediaStandard) standardMediaId = box.dataset.mediaStandard;
      if (box.dataset.cartTotal) cartTotal = parseInt(box.dataset.cartTotal, 10) || 0;
      const map = availMapFor(box);
      const current = box.dataset.current;
      if (map && current && map[current]) {
        paintAvail(box, map[current]);
        paintTax(map[current]);
      }
    });

    // Warenkorb ändert sich (Artikel hinzugefügt): Hinweis neu bewerten
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
        const gesamt = payload && payload.cartData && payload.cartData.total_price;
        if (typeof gesamt === 'number') {
          cartTotal = gesamt;
          repaintTaxForCurrent();
        } else {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((c) => { cartTotal = c.total_price || 0; repaintTaxForCurrent(); })
            .catch(() => {});
        }
      });
    }

    // Kanal 1 (wie im alten Setup): das versteckte Varianten-Feld meldet sich –
    // delegiert am Dokument, damit es auch nach DOM-Austausch weiter greift.
    document.addEventListener('change', (event) => {
      const el = event.target;
      if (!el || el.name !== 'id') return;
      applyVariant(String(el.value));
    });

    // Kanal 2 (wie im alten Setup): eigenes variant:change-Ereignis
    document.addEventListener('variant:change', (event) => {
      const v = event.detail && event.detail.variant;
      if (v && v.id) applyVariant(String(v.id));
    });

    // Kanal 3: Theme-eigenes PubSub-Ereignis
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
        const variant = (payload && payload.data && payload.data.variant) || (payload && payload.variant) || null;
        if (variant && variant.id) applyVariant(String(variant.id));
        else setTimeout(readVariantFromForm, 300);
      });
    }

    // Kanal 4: Radio-Klick als Absicherung (liest kurz danach das Formular)
    document.addEventListener('change', (event) => {
      const el = event.target;
      if (!el || !el.matches) return;
      if (!el.matches('variant-selects input[type="radio"], .product-form__input input[type="radio"]')) return;
      setTimeout(readVariantFromForm, 250);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
